import styled from "styled-components";

/**
 * ダウンロードダイアログのスタイルコンポーネント
 * htdocs_ab/app/views/dl/index.ctp のデザインを参考に作成
 */

// メインコンテナ
const DownloadContainer = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 4px;
  /* background-color: white; */
  box-sizing: border-box;
`;

// ダウンロード一覧コンテナ
const DownloadListContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  min-height: 200px;
`;

// ダウンロードテーブル
const DownloadTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
`;

// ダウンロード行
const DownloadRow = styled.tr`
  height: 30px;
  font-size: 16px;
  &:hover {
    background-color: #f5f5f5;
  }
`;

// ダウンロードセル
const DownloadCell = styled.td`
  padding: 8px;
  vertical-align: middle;
  white-space: nowrap;
  width: ${(props) => props.width || "auto"};
  text-align: ${(props) => props.align || "left"};
`;

// ダウンロードリンク
const DownloadLink = styled.a`
  display: inline-block;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  /* padding: 10px 15px; */
  border-radius: 3px;
  background-color: ${(props) => props.bgColor || "#b3ffcc"};
  transition: all 0.2s ease;
  min-height: 30px;
  line-height: 30px;
  box-sizing: border-box;

  &:hover {
    background-color: ${(props) => {
      const color = props.bgColor || "#b3ffcc";
      // 色を少し暗くする
      if (color === "#b3ffcc") return "#99ffbb";
      if (color === "#b3ffff") return "#99ffff";
      return color;
    }};
    text-decoration: none;
    color: #000;
  }

  &:visited {
    color: #333;
  }
`;

// 閲覧済みステータス
const ViewedStatus = styled.span`
  color: #ff0000;
  font-size: 16px;
  font-weight: bold;
`;

// 空メッセージ
const EmptyMessage = styled.div`
  text-align: center;
  font-size: 16px;
  color: #000;
  padding: 40px 20px;
  /* background-color: #f9f9f9; */
  /* border-radius: 5px; */
  /* border: 1px solid #ddd; */
`;

// エラーメッセージ
const ErrorMessage = styled.div`
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  padding: 10px;
  margin: 10px 0;
  font-size: 14px;
`;

// 成功メッセージ
const SuccessMessage = styled.div`
  background: #e8f5e8;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
  border-radius: 4px;
  padding: 10px;
  margin: 10px 0;
  font-size: 14px;
`;

// ローディング表示
const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
`;

// タイトル
const DownloadTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 24px;
  color: #333;
  font-weight: bold;
  text-align: center;
`;

// 注文詳細セクション（htdocs_ab/app/views/dl/index.ctp の order_detail クラスを参考）
const OrderDetail = styled.div`
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 5px;
`;

// 注文詳細タイトル
const OrderDetailTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 24px;
  color: #333;
  font-weight: bold;
  text-align: center;
`;

// レスポンシブ対応
const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    padding: 15px;

    ${DownloadTable} {
      width: 100%;
    }

    ${DownloadLink} {
      font-size: 14px;
      padding: 8px 12px;
    }
  }
`;

// 閉じるボタン
const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 3px;
  transition: background-color 0.2s;

  &:hover {
    background: #f0f0f0;
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

// ダウンロードボタン
const DownloadButton = styled.button`
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #45a049;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

// ステータス表示
const StatusDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
`;

// 日付表示
const DateDisplay = styled.span`
  font-size: 12px;
  color: #888;
  margin-left: 8px;
`;

const DownloadDialogStyles = {
  DownloadContainer,
  DownloadListContainer,
  DownloadTable,
  DownloadRow,
  DownloadCell,
  DownloadLink,
  ViewedStatus,
  EmptyMessage,
  ErrorMessage,
  SuccessMessage,
  LoadingOverlay,
  DownloadTitle,
  OrderDetail,
  OrderDetailTitle,
  ResponsiveContainer,
  CloseButton,
  DownloadButton,
  StatusDisplay,
  DateDisplay,
};

export default DownloadDialogStyles;
